import useLocalStorage from './use-local-storage';

export { useLocalStorage };

export default useLocalStorage;
